import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Icd10CodeSearchConfiguration implements IIcd10CodeSearchConfiguration {
  rootUrl!: string;
}

export interface IIcd10CodeSearchConfiguration {
  rootUrl: string;
}
